// extracted by mini-css-extract-plugin
module.exports = {"downloadButtonMobile":"_prYYXv8","downloadButtonDesktop":"_9NtxbVJe","isTopScroll":"_9RglED_c"};